import { neutrals, brand, text } from 'src/theme/colors';
import { StyleSheet } from 'react-native';
import { Brand, Neutrals } from 'src/theme-v2/colors';
import { textLatoStyleDS } from 'src/theme-v2/text';

export const styles = StyleSheet.create({
  card: {
    flexDirection: 'column',
    gap: 8,
    borderTopRightRadius: 16,
    borderTopLeftRadius: 16,
  },
  image: {
    backgroundColor: '#CCCCCC',
  },
  textBadge: {
    fontWeight: 700,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.white,
  },
  badge: {
    position: 'absolute',
    top: 0,
    left: 0,
    flexDirection: 'row',
    paddingHorizontal: 10,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    paddingVertical: 5,
    borderTopLeftRadius: 24,
    borderBottomRightRadius: 24,
    gap: 4,
    backgroundColor: brand.main.water,
  },
  outerBorder: {
    position: 'absolute',
    borderRadius: 16,
  },
  innerContainer: {
    margin: 2,
    borderRadius: 15,
    overflow: 'hidden',
    backgroundColor: neutrals.white,
  },
  textDescription: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 16,
    color: neutrals.neutralGrays.cement,
  },
  radioButton: {
    position: 'absolute',
    top: 8,
    right: 8,
    width: 20,
    height: 20,
    borderRadius: 10,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Neutrals.main.White,
  },
  imageDisabled: {
    opacity: 0.6,
  },
  subTag: {
    backgroundColor: brand.main.mustard,
    position: 'absolute',
    top: 2,
    left: 2,
    flexDirection: 'row',
    paddingHorizontal: 8,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1,
    paddingVertical: 4,
    borderTopLeftRadius: 18,
    borderBottomRightRadius: 18,
    gap: 4,
  },
  subTagText: {
    fontWeight: 700,
    fontSize: 10,
    lineHeight: 14,
    letterSpacing: 0,
    color: neutrals.white,
  },
  textContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignSelf: 'center',
    gap: 8,
  },
  textContainerColumn: {
    justifyContent: 'center',
    alignSelf: 'center',
    gap: 8,
  },
  textWrapperCenter: {
    alignItems: 'center',
    justifyContent: 'center',
  },
  price: {
    ...textLatoStyleDS.BodyBoldMd,
    color: Neutrals.neutralGreys.GreyNatural900,
  },
  priceColored: {
    ...textLatoStyleDS.BodyBoldMd,
    color: Brand.orange.Orange600,
  },
  priceDiscount: {
    ...textLatoStyleDS.BodyRegularSm,
    color: Neutrals.neutralGreys.GreyNatural900,
    textDecorationLine: 'line-through',
  },
  description: {
    fontWeight: 400,
    fontSize: 14,
    lineHeight: 18,
    color: text.color.textTertiary,
  },
  textTitle: {
    ...textLatoStyleDS.BodyBoldMd,
    color: Neutrals.neutralGreys.GreyNatural900,
  },
  icon: {
    width: 18,
    height: 18,
    alignSelf: 'center',
  },
  textDescriptionLeft: {
    flex: 1,
    flexDirection: 'row',
    gap: 8,
    alignSelf: 'flex-start',
    paddingHorizontal: 16,
    minHeight: 36,
  },
  bottomContainer: { width: '100%', paddingVertical: 8, gap: 4 },
});
